module.exports = __webpack_public_path__ + "static/media/gen_img33.eb6bd682.png";